import React, {useEffect, useState, useRef} from "react";
import {Account} from "./common/CommonModel";
import {useHistory, useLocation, useParams} from "react-router-dom";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { apollo_useStyles, options_state_edit, options_state_edit_ms, options_quasi_reservation_state_edit_ms, quasi_reservation_state_number, valueToOption } from "../../../atom/Apollo_styles";
import {accountdetailapollo_path, post_ms_accounts_upd_path, get_ms_account_path, budget_path} from "../../../atom/Apollo_links";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, IsAuthorization} from "../../../atom/Apollo_Authorization";
import GenericTemplate from "../../../templates/GenericTemplate";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloBasicLabel} from "../../../molecule/Apollo_BaseItem";
import {BLANK, FORMAT_YYYY_MM_DD_HHmm, INIT_NUMBER, INIT_STR, MSG, RESULT_KBN} from "./common/CommonConst";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {DATE_TIME_SUFFIX} from "../../SUMMARY/IndividualSummary";

import {ApolloEventRecord, LogData, ItemList} from "../../../atom/Apollo_EventRecord";

const INIT_ACCOUNT = {
    adAccountId: INIT_NUMBER,
    adAccountsGroupId: INIT_NUMBER,
    adAccountsName: INIT_STR,
    adAccountsStatus: INIT_NUMBER,
    adClientId: INIT_NUMBER,
    adClientName: INIT_STR,
    adCompanyName: INIT_STR,
    chargeRequestId: INIT_NUMBER,
    chargeResourseName: INIT_STR,
    cpmThismonth: INIT_NUMBER,
    cpmRtmThismonth: INIT_NUMBER,
    cpmNextmonth: INIT_NUMBER,
    cpmRtmNextmonth: INIT_NUMBER,
    createdDatetime: INIT_STR,
    industryId: INIT_NUMBER,
    lastUpdatedUserId: INIT_STR,
    lastUpdatedVer: INIT_STR,
    productId: INIT_NUMBER,
    siteUrl: INIT_STR,
    updatedDatetime: INIT_STR,
    quasiReservationStatus: INIT_NUMBER,
}

const breadcrumbsData: BreadcrumbsData = {
    categoryId: 11,
    breadId: 1,
    queries: [],
    menu: {
        id: 2,
        accountId: "",
        accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
}

/*
    画面名：アカウント詳細（MS）
 */
const AccountDetailMs: React.FC = () => {

    const classes = apollo_useStyles();
    let history = useHistory();
    const {accountgroupid, accountid, platformaccountid} = useParams();
    
    const QUERY_NAME_1 = "type";  // クエリパラメータ名
    const QUERY_NAME_2 = "month"; // クエリパラメータ名

    const QUERY_TYPE_1 = "bu";  // 予算管理詳細から
    const query1 = new URLSearchParams(useLocation().search);
    const queryType = query1.has(QUERY_NAME_1) ? query1.get(QUERY_NAME_1) : "";
    const budgetMonth1 = query1.has(QUERY_NAME_2) ? query1.get(QUERY_NAME_2) : moment().format("YYYYMM");

    const handelGoback = () => {
        if (queryType === QUERY_TYPE_1) {
            const url = budget_path + "/" + accountid + "/" + budgetMonth1;
            history.push(url);
        } else {    
            history.push(`${accountdetailapollo_path}${accountgroupid}/${accountid}`);
        }
    };

    return (
        <GenericTemplate title="">
            <ApolloBreadcrumbs2 data={breadcrumbsData}/>
            <React.Fragment>
                <Card className={classes.root} square variant="outlined">
                    <CardContent>
                        <AccountMs adAccountGroupId={accountgroupid} platformAccountId={platformaccountid}/>
                    </CardContent>
                    <CardActions className={classes.cardaction}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handelGoback}
                            className={classes.button}
                        >
                            戻る
                        </Button>
                    </CardActions>
                </Card>
            </React.Fragment>
            <CustomizedSnackbars/>
        </GenericTemplate>
    );
};

const AccountMs: React.FC<{
    adAccountGroupId: number,
    platformAccountId: number,
}> = ({adAccountGroupId, platformAccountId}) => {
    const classes = apollo_useStyles();
    const {state} = React.useContext(ApolloContext);
    const {data, setmsg} = React.useContext(ApolloMessage);
    const [account, setAccount] = useState<Account>(INIT_ACCOUNT);
    const processing = useRef(false);
    const products = [
        {
            id: 'adAccountId',
            name: 'メール広告アカウントID',
            value: account.adAccountId
        },
        {
            id: 'adAccountsName',
            name: 'メール広告アカウント名',
            value: account.adAccountsName
        },

        {
            id: 'adClientName',
            name: '広告主名',
            value: account.adClientName
        },
        {
            id: 'cpmThismonth',
            name: '月額上限予算（当月）メッセージS',
            value: account.cpmThismonth || account.cpmThismonth === 0 ? `￥${account.cpmThismonth.toLocaleString()}` : BLANK
        },
        {
            id: 'cpmThismonth',
            name: '月額上限予算（翌月）メッセージS',
            value: account.cpmNextmonth || account.cpmNextmonth === 0 ? `￥${account.cpmNextmonth.toLocaleString()}` : BLANK
        },
        // {
        //     id: 'cpmRtmThismonth',
        //     name: '月額上限予算（当月）リアルタイムメッセージS',
        //     value: account.cpmRtmThismonth || account.cpmRtmThismonth === 0 ? `￥${account.cpmRtmThismonth.toLocaleString()}` : BLANK
        // },
        // {
        //     id: 'cpmRtmNextmonth',
        //     name: '月額上限予算（翌月）リアルタイムメッセージS',
        //     value: account.cpmRtmNextmonth || account.cpmRtmNextmonth === 0 ? `￥${account.cpmRtmNextmonth.toLocaleString()}` : BLANK
        // },
        {
            id: 'adAccountsStatus',
            name: 'ステータス',
            // 広告主アカウントステータスが「6:アーカイブ」の時は、自動的に「3:一時停止」とする
            value: account.adAccountsStatus
                ? valueToOption(account.adAccountsStatus === 6 ? 3 : account.adAccountsStatus, options_state_edit_ms).label
                : BLANK
        },
        {
            id: 'quasiReservationStatus',
            name: '準予約ステータス',
            value: account.quasiReservationStatus != null
                ? valueToOption(account.quasiReservationStatus, options_quasi_reservation_state_edit_ms).label
                : BLANK
        },
        {
            id: 'siteUrl',
            name: 'サイトURL',
            value: account.siteUrl
        },
        {
            id: 'createdDatetime',
            name: '作成日時',
            value: account.createdDatetime ? moment(account.createdDatetime?.replace(DATE_TIME_SUFFIX, BLANK)).format(FORMAT_YYYY_MM_DD_HHmm) : BLANK
        },
        {
            id: 'updatedDatetime',
            name: '更新日時',
            value: account.updatedDatetime ? moment(account.updatedDatetime?.replace(DATE_TIME_SUFFIX, BLANK)).format(FORMAT_YYYY_MM_DD_HHmm) : BLANK
        },
    ];

    useEffect(() => {
        initialData();
    }, []);

    const initialData = async () => {
        const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_account_path}/${adAccountGroupId}/${platformAccountId}`;
        await ApolloAxios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${state.accesstoken}`,
            },
        }).then((response) => {
            if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                setAccount(response.data.result);
            } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...data,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_ACCOUNT}${response.data?.message ?? BLANK}`
                    }
                });
            }
        }).catch(err => {
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: `${MSG.ERR_GET_ACCOUNT}${err?.errmsg ?? BLANK}`
                }
            });
        });
    }

    const handleChange = async (id: string) => {
        if (processing.current) return;
        processing.current = true;
        let isSuccess = false;

        const updAccount: Account = {
            ...account,
        };

        let itemList: ItemList[] = [];

        if (id === 'adAccountsStatus') {
            // アカウントステータスのボタン押下時
            switch (account.adAccountsStatus) {
                case 2:
                    updAccount.adAccountsStatus = 3;
                    break;
                case 3:
                case 6:
                    updAccount.adAccountsStatus = 2;
                    break;
            }
            // 実行時ログ
            itemList.push({
                key: "ステータス",
                beforeValue: valueToOption(account.adAccountsStatus === 6 ? 3 : account.adAccountsStatus, options_state_edit_ms).label,
                afterValue: valueToOption(updAccount.adAccountsStatus, options_state_edit_ms).label,
            });
        } else if (id === 'quasiReservationStatus') {
            // 準予約ステータスのボタン押下時
            switch (account.quasiReservationStatus) {
                case quasi_reservation_state_number.PAUSE:
                    updAccount.quasiReservationStatus = quasi_reservation_state_number.APPROVAL;
                    break;
                case quasi_reservation_state_number.APPROVAL:
                    updAccount.quasiReservationStatus = quasi_reservation_state_number.PAUSE;
                    break;
            }
            // 実行時ログ
            itemList.push({
                key: "準予約ステータス",
                beforeValue: valueToOption(account.quasiReservationStatus, options_quasi_reservation_state_edit_ms).label,
                afterValue: valueToOption(updAccount.quasiReservationStatus, options_quasi_reservation_state_edit_ms).label,
            });
        }

        const executionLog: LogData = {
            eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            logType: "execute",
            result: "",
            userID: state.userprofile.userId,
            userName: state.userprofile.userName,
            accessToken: state.accesstoken ,
            accountGroupID : state.current.accountGroupId,
            accountGroupName: state.current.accountGroupName,
            accountID : state.current.accountId,
            accountName: state.current.accountName,
            campaignID: "", // キャンペーンID
            campaignName: "", // キャンペーン名
            adGroupID: "", // 広告グループID
            adGroupName: "", // 広告グループ名
            menu: "",
            displayName: "メール広告アカウント詳細画面",
            category: "アカウント管理",
            actionType: "更新",
            targetID: account.adAccountId + "",
            targetName: account.adAccountsName,
            itemList: itemList,
        }
        ApolloEventRecord(executionLog);
  
        const url = `${process.env.REACT_APP_API_ENDPOINT}${post_ms_accounts_upd_path}`;
        await ApolloAxios.post(url, updAccount)
            .then((response) => {
                const res: ApiResponse = response.data
                if (isSuccessApi(res.resultCode)) {
                    isSuccess = true;
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "success",
                            message: `${MSG.SUCCESS_UPD_STATUS}`
                        }
                    });
                } else {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_UPD_STATUS}${res.message ?? BLANK}`
                        }
                    });
                }
            })
            .catch((err) => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...data,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_UPD_STATUS}${err?.errmsg ?? BLANK}`
                    }
                });
            })
            .finally(() => {
                // 実行結果ログ
                const resultLog: LogData = {
                    ...executionLog,
                    eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                    logType: "result",
                    result: isSuccess? "成功" : "失敗",
                }
                ApolloEventRecord(resultLog);
  
                if (isSuccess) {
                    initialData();
                }

                processing.current = false;
            });
    }

    return (
        <React.Fragment>
            <Grid container spacing={3} style={{marginBottom: "5px"}}>
                {products?.map((data, index) => 
                !(
                    //システム管理者以外の場合、準予約ステータス非表示
                    state.userprofile.systemAdmin !== APOLLO_PROFILE_SYSTEM_ADMIN && data.id === 'quasiReservationStatus'
                )
                &&(
                    <React.Fragment key={index}>
                        <Grid item xs={6}>
                            <Typography>{data.name}</Typography>
                        </Grid>
                        {IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN)
                            && (data.id === 'adAccountsStatus' && account?.adAccountsStatus !== null
                                || data.id === 'quasiReservationStatus' && account?.quasiReservationStatus !== null)
                            ? <React.Fragment>
                                <Grid item xs={1}>
                                    <Typography>{data.value}</Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Button
                                        className={classes.buttonTop}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => handleChange(data.id)}
                                        disabled={processing.current}
                                    >
                                        {((data.id === 'adAccountsStatus' &&
                                            account.adAccountsStatus === 2)
                                            ||
                                            (data.id === 'quasiReservationStatus' &&
                                                account.quasiReservationStatus === quasi_reservation_state_number.APPROVAL))
                                            ? "一時停止"
                                            : "有効"
                                        }
                                    </Button>
                                </Grid>
                            </React.Fragment>
                            : <Grid item xs={6}>
                                <Typography>{data.value}</Typography>
                            </Grid>
                        }
                    </React.Fragment>
                ))}
            </Grid>
        </React.Fragment>
    );
}

export default AccountDetailMs;
